
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uk/home",
      function () {
        return require("private-next-pages/uk/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uk/home"])
      });
    }
  